import { __assign } from 'tslib';
import 'react-stately';

var checkIsGroup = function (suggestion) {
    var _a;
    return Boolean((suggestion === null || suggestion === void 0 ? void 0 : suggestion.title) && ((_a = suggestion.options) === null || _a === void 0 ? void 0 : _a.length));
};
var flattenSuggestions = function (suggestions) {
    return suggestions
        .filter(function (_a) {
        var label = _a.label, value = _a.value, options = _a.options, title = _a.title;
        return (label && value) || ((options === null || options === void 0 ? void 0 : options.length) && title);
    })
        .flatMap(function (suggestion) {
        if (checkIsGroup(suggestion) && suggestion.options) {
            return suggestion.options.map(function (option) { return (__assign({}, option)); });
        }
        else {
            return suggestion;
        }
    });
};

export { checkIsGroup, flattenSuggestions };
//# sourceMappingURL=Utils.js.map
